import useAjax from "@hooks/use-ajax.hook";
import dayjs from "dayjs";
import { useCallback } from "react";
import { ReservationType } from "src/types/types";

type AddReservationType = Omit<ReservationType, "id" | "price" | "status">;

const useAddReservation = () => {
  const { request, error, loading, clearError } = useAjax();

  const addReservation = useCallback(
    (reservation: AddReservationType) =>
      request<number>(
        "add_reservation",
        {
          ...reservation,
          date: dayjs(reservation.date).format("YYYY-MM-DD"),
        },
        undefined,
        { thank: "you" }
      ),
    [request]
  );

  return { addReservation, loading, error, clearError };
};

export default useAddReservation;
